import { useContext } from "react";
import { APILoadingContext } from "../providers/APILoadingProvider";

export default function useLoadingBackdrop() {
  const { loading, showLoadingBackdrop, removeLoadingBackdrop } =
    useContext(APILoadingContext);
  return { loading, showLoadingBackdrop, removeLoadingBackdrop };
}
